module.exports = __webpack_public_path__ + "media/stylesheets/images/lp/industry-05-7b90dfcc5530b0b9ab493677fc823110.png";